import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button} from 'views/components';
import {Add} from 'views/icons';
import {Translate, DeleteConfirmDialog} from 'views/module';

import ReviewCard from './ReviewCard';
import AddReview from './AddReview';

const Review = (props) => {
  const {
    caregiverRn,
    caregiverReviews,
    caregiverBackend,
  } = props;

  const [isAddingReview, setIsAddingReview] = React.useState(false);
  const [isShowingConfirmDeleteDialog, setIsShowingConfirmDeleteDialog] = React.useState(false);
  const [reviewToDelete, setReviewToDelete] = React.useState(null);

  const handleDelete = () => {
    const onSuccess = () => {
      setReviewToDelete(null);
      setIsShowingConfirmDeleteDialog(false);
    };

    caregiverBackend.reviews.removeCaregiverReview(reviewToDelete, onSuccess);
  };

  return (
    <Stack
      spacing={2}
      width="100%"
      alignItems="center"
      sx={{
        p: 2,
        bgcolor: 'grey.100',
      }}
    >
      {
        caregiverReviews.map((review) => (
          <ReviewCard
            isShowingConfirmDeleteDialog={isShowingConfirmDeleteDialog}
            setIsShowingConfirmDeleteDialog={setIsShowingConfirmDeleteDialog}
            setReviewToDelete={setReviewToDelete}
            caregiverBackend={caregiverBackend}
            key={review.caregiverReviewRn}
            review={review}
          />
        ))
      }
      {
        isAddingReview &&
        <AddReview
          caregiverRn={caregiverRn}
          caregiverBackend={caregiverBackend}
          isAddingReview={isAddingReview}
          setIsAddingReview={setIsAddingReview}
        />
      }
      <Button
        variant="outlined"
        startIcon={<Add/>}
        onClick={() => setIsAddingReview(true)}
        sx={{
          borderStyle: 'dashed',
          borderWidth: 3,
          py: 1.5,
          textTransform: 'none',
        }}
      >
        <Translate expression="caregiver.CaregiverReview.AddReviewButtonLabel" />
      </Button>
      {
        isShowingConfirmDeleteDialog &&
        <DeleteConfirmDialog
          setDialogOpen={setIsShowingConfirmDeleteDialog}
          onClickConfirmDelete={handleDelete}
        />
      }
    </Stack>
  );
};

Review.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  caregiverReviews: PropTypes.array.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(Review);
